export const GET_USER_SETTINGS_BY_ID = "GET_USER_SETTINGS_BY_ID";
export const GET_USER_SETTINGS_BY_ID_SUCCESS =
  "GET_USER_SETTINGS_BY_ID_SUCCESS";
export const GET_USER_SETTINGS_BY_ID_FAILURE =
  "GET_USER_SETTINGS_BY_ID_FAILURE";

export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
export const UPDATE_USER_SETTINGS_SUCCESS = "UPDATE_USER_SETTINGS_SUCCESS";
export const UPDATE_USER_SETTINGS_FAILURE = "UPDATE_USER_SETTINGS_FAILURE";
